import axios from 'axios';

export const getRoles = async () => {
  const { data } = await axios.get('/UserRole');
  return data;
};

/**
 * Readable message for a failed roles call. A 403 here means the signed-in
 * role is missing the UserRole.List claim - without this the page renders an
 * empty table, which reads as "no roles exist" instead of "not allowed".
 */
export const rolesErrorMessage = (error) => {
  const status = error?.response?.status;
  if (status === 401 || status === 403) return 'You are not authorized to view roles';
  const body = error?.response?.data ?? {};
  return body.Message || body.message || error?.message || 'Something went wrong';
};

export const editRole = async (e) => {
  const mutation = await axios.post(`/UserRole/Edit`, e);
  const data = mutation.data.data;
  const isDone = mutation.data.isDone;
  return { data, isDone };
};

export const addRole = async (e) => {
  const mutation = await axios.post(`/UserRole?name=${e.name}`);
  const data = mutation.data.data;
  const isDone = mutation.data.isDone;
  return { data, isDone };
};
export const deleteRole = async (id) => {
  const mutation = await axios.get(`/UserRole/Delete?id=${id}`);
  const data = mutation.data.data;
  const isDone = mutation.data.isDone;
  return { data, isDone };
};

// export const getPermissions = async (roleName) => {
//   const { data } = await axios.get(`/Permission/GetRole/${roleName}`);
//   return data;
// };

export const getPermissions = (roleName) => {
  return async () => {
    const { data } = await axios.get(`/Permission/GetRole/${roleName}`);
    return data;
  };
};

/**
 * Every permission the API actually knows about (GET /Permission).
 * The picker used to read a hard coded list that had drifted out of date, so
 * whole modules could not be granted at all. Needs the RolePerm.List claim.
 */
export const getAllSystemPermissions = async () => {
  const { data } = await axios.get('/Permission');
  if (!data?.isDone) throw new Error(data?.message || 'Could not load permissions');
  // The backend reflects over its Permission classes and can repeat a value.
  return [...new Set(data.data ?? [])];
};

export const editPermissions = async (e) => {
  const mutation = await axios.post(`/Permission/Role`, e);
  const data = mutation.data.data;
  const isDone = mutation.data.isDone;
  return { data, isDone };
};
